import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Login = ({ onLoginSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false); // Loading state
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission

    // Check if login request is already in progress
    if (isLoading) {
      console.log('Login request is already in progress, preventing double submit');
      return; // Exit early if already in progress
    }

    setIsLoading(true); // Set loading to true to prevent double submissions
    setErrorMessage(''); // Clear any previous error messages

    // Validate form inputs
    if (!email || !password) {
      setErrorMessage('Please enter both email and password');
      setIsLoading(false); // Reset loading state
      return;
    }

    try {
      console.log('Making login request...');
      // Make the login API request
      const response = await fetch('https://schoolofservice.co.za/backend/login.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();
      console.log('Login Response:', data); // Log the response for debugging

      if (response.ok && data.user) {
        // On successful login, store the user data in localStorage
        if (data.message === 'Login successful') {
          localStorage.setItem('isLoggedIn', 'true');
          localStorage.setItem('userId', data.user.userID); // Store the userID
          localStorage.setItem('user', JSON.stringify(data.user)); // Optionally, store the whole user object

          // Call the parent component's callback with the user data
          onLoginSuccess(data.user);

          // Redirect based on user role
          if (data.user.role === 'admin') {
            navigate('/admin');
          } else {
            navigate('/dashboard');
          }
        } else {
          setErrorMessage(data.message || 'Invalid credentials');
        }
      } else {
        setErrorMessage(data.message || 'Invalid credentials');
      }
    } catch (error) {
      console.error('Login error:', error);
      setErrorMessage('An error occurred. Please try again.');
    } finally {
      setIsLoading(false); // Reset loading state
    }
  };

  return (
    <div className="container py-5">
      <h2 className="text-center mb-4">Login</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="email" className="form-label">Email</label>
          <input
            type="email"
            className="form-control"
            id="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="password" className="form-label">Password</label>
          <input
            type="password"
            className="form-control"
            id="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        {/* Display error message */}
        {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

        {/* Display loading state */}
        <button 
          type="submit" 
          className="btn btn-primary w-100" 
          disabled={isLoading}
        >
          {isLoading ? 'Loading...' : 'Login'}
        </button>
      </form>
    </div>
  );
};

export default Login;
